<script>
import { Pie, mixins } from 'vue-chartjs'
export default {
  extends: Pie,
  mixins: [mixins.reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    values: {
      type: Array,
      default: null
    },
    width: {
      type: Number,
      default: null
    },
    height: {
      type: Number,
      default: null
    }
  },
  mounted () {
    this.renderChart(this.chartData, Object.assign({onClick: this.handle}, this.options))
  },
  methods: {
    handle (point, event) {
      const item = event[0]
      this.$emit('clicked', this.values[item._index])
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PieChart.vue